//imports here
import mobile_nav from "./mobile_nav";
import gap_calculator from "./gap_calculator";
import bike_calculator from "./bike_calculator";
import tab_comparison from "./tab_comparison";
import "slick-carousel/slick/slick";
import homebanner from "./homebanner";
import homepagebanner from "./homepage-banner";
import brand_cards from "./brand_cards";
import swipe_cards from "./swipe_cards";
import tier_list from './components/service-tier-list';
import scrollingTitles from './scrolling_titles';
import graphic_carousel from './components/graphic-carousel';
import videoBlock from './components/video-block';
import reviews_carousel from './components/reviews-carousel';
import text_card_carousels from './components/text-card-carousels';
import heroBanner from './components/hero-banner';
import form_floating_labels from "./floating-form-labels";
import selects from "./selects";
import underwriterSelect from './components/underwriter-select';
import author_blogs from "./components/author-blogs";
import table_full_width from "./components/table-full-width";
import dropdown_comparison from "./components/dropdown-comparison";
import explanation_carousel from "./components/explanation-carousel";
import cards_with_buttons from "./components/cards_with_buttons";
import table_comparison from "./components/table-comparison";
import information_tab_table from "./components/information-tab-table";
import blog_posts_carousel from "./components/blog-posts-carousel";
import steps_carousel from "./components/steps-carousel";
import table_slider from "./table-slider";
import filter from "./components/filter";
import promotion_card from "./components/promotion-card";
import image_carousel from './components/image-carousel';
import text_tab from './components/text-tab';
import breadcrumbs from './components/breadcrumbs';
import pop_up from "./components/pop-up";
import information_tabs from "./components/information-tabs";
import plan_tabs from "./components/plan-tabs";
import scroll_to_anchor from "./scroll-to-anchor";
import search from "./components/search";
import infomational_banner_text_blocks from "./components/informational-banner-text-blocks";
import infomational_banner_reviews from "./components/informational-banner-reviews";
import manufacturers_select from "./components/manufacturers-select";
import contact_overlay from "./contact-overlay";
import header_nav from "./header-nav";
import AOS from "aos";
import stickyNav from './components/sticky-nav';
import policyAutoscroll from './components/policy-autoscroll';
import faqsV2 from './components/faqs-v2';
import newsletter_validation from './newsletter-validation';
// init()

jQuery(window).on('load', function () {
    gap_calculator();
});

jQuery(function () {
    header_nav();
    contact_overlay();
    search();
    mobile_nav();
    bike_calculator();
    tab_comparison();
    homepagebanner();
    brand_cards();
    swipe_cards();
    tier_list();
    scrollingTitles.init();
    graphic_carousel();
    text_card_carousels();
    videoBlock.init();
    reviews_carousel();
    heroBanner.init();
    form_floating_labels();
    selects();
    underwriterSelect.init();
    author_blogs();
    table_full_width();
    dropdown_comparison();
    cards_with_buttons();
    table_comparison();
    blog_posts_carousel();
    table_slider();
    information_tab_table();
    explanation_carousel();
    promotion_card();
    image_carousel();
    steps_carousel();
    filter();
    text_tab();
    breadcrumbs();
    pop_up();
    information_tabs();
    plan_tabs();
    scroll_to_anchor();
    infomational_banner_text_blocks();
    infomational_banner_reviews();
    manufacturers_select();
    newsletter_validation();
    AOS.init({
        startEvent: 'load',
        once: true,
        disableMutationObserver: false, 
        duration: 500, // values from 0 to 3000, with step 50ms
        easing: 'ease',
    });
    AOS.refresh(true); 

    $(".sub-menu--inner a").on("touchstart", function () {
      var href = $(this).attr("href");
      if(href) {
        location.href = href;
      }
    });
    // stickyNav();
    // faqsV2();
});